namespace RioERP.Products {
    export interface SubjectsForm {
        CategoryId: Serenity.LookupEditor;
        Name: Serenity.StringEditor;
        Description: Serenity.StringEditor;
    }

    export class SubjectsForm extends Serenity.PrefixedContext {
        static formKey = 'Products.Subjects';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!SubjectsForm.init)  {
                SubjectsForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.StringEditor;

                Q.initFormType(SubjectsForm, [
                    'CategoryId', w0,
                    'Name', w1,
                    'Description', w1
                ]);
            }
        }
    }
}
